import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Form,
  Input,
  Label,
  Row,
} from 'reactstrap'
// import moment from 'moment'
import { Fragment, useCallback, useEffect, useRef, useState } from 'react'
import Select from 'react-select'
import { Controller, useForm } from 'react-hook-form'
import SchemaValidations from './validations'
import ResponsiveDatePickers from '../../../components/date-picker'
import { useDispatch, useSelector } from 'react-redux'
import {
  getReceptionDocuments,
  getReceptionDocumentsReportsFile,
} from '../store'
// import toast from 'react-hot-toast'

const typeOptions = [
  { value: 'NIT', label: 'NIT' },
  { value: 'NRC', label: 'NRC' },
  { value: 'DUI', label: 'DUI' },
]

const initialFilterProps = {
  name: '',
  email: '',
  type: typeOptions[0],
  typeValue: '',
  dteType: '',
  startDate: null,
  endDate: null,
}

export function ReceptionDocumentsFilters() {
  const dispatch = useDispatch()
  const { currentPage, data, isPending } = useSelector(
    (state) => state.receptionDocuments
  )

  const abortControllerRef = useRef(null)
  const [filterProps, setFilterProps] = useState(initialFilterProps)

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...initialFilterProps,
    },
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(SchemaValidations),
  })

  useEffect(() => {
    getData()

    return () => {
      abortControllerRef.current?.abort()
    }
  }, [currentPage])

  const parseFilters = ({
    startDate,
    endDate,
    name,
    email,
    type,
    typeValue,
    dteType,
  }) => {
    const currentFilters = {}

    if (startDate) currentFilters['fechaDesde'] = startDate
    if (endDate) currentFilters['fechaHasta'] = endDate
    if (name) currentFilters['emisorNombre'] = name
    if (email) currentFilters['emisorCorreo'] = email
    if (dteType) currentFilters['tipoDte'] = dteType

    if (typeValue) {
      if (type) currentFilters['tipoDoc'] = type

      currentFilters['numDoc'] = typeValue
    }

    return currentFilters
  }

  const getData = () => {
    const name = filterProps.name?.trim() || ''
    const email = filterProps.email?.trim() || ''
    const type = filterProps.type?.value?.trim() || ''
    const typeValue = filterProps.typeValue?.trim() || ''
    const dteType = filterProps.dteType?.trim() || ''
    const startDate = filterProps.startDate?.format('YYYY-MM-DD') ?? ''
    const endDate = filterProps.endDate?.format('YYYY-MM-DD') ?? ''

    if (
      // name &&
      // email &&
      // type &&
      // typeValue &&
      // dteType &&
      startDate &&
      endDate
    ) {
      if (abortControllerRef.current) {
        abortControllerRef.current?.abort() // Cancelar petición anterior si existe
      }

      abortControllerRef.current = new AbortController()

      const currentFilters = parseFilters({
        startDate,
        endDate,
        name,
        email,
        type,
        typeValue,
        dteType,
      })

      dispatch(
        getReceptionDocuments({
          filters: currentFilters,
          page: currentPage,
          signal: abortControllerRef.current.signal,
        })
      )
    }
  }

  const getFile = () => {
    const name = filterProps.name?.trim() || ''
    const email = filterProps.email?.trim() || ''
    const type = filterProps.type?.value?.trim() || ''
    const typeValue = filterProps.typeValue?.trim() || ''
    const dteType = filterProps.dteType?.trim() || ''
    const startDate = filterProps.startDate?.format('YYYY-MM-DD') ?? ''
    const endDate = filterProps.endDate?.format('YYYY-MM-DD') ?? ''

    if (
      // name &&
      // email &&
      // type &&
      // typeValue &&
      // dteType &&
      startDate &&
      endDate
    ) {
      const currentFilters = parseFilters({
        startDate,
        endDate,
        name,
        email,
        type,
        typeValue,
        dteType,
      })

      dispatch(
        getReceptionDocumentsReportsFile({
          filters: currentFilters,
        })
      ).then((response) => {
        if (response.error) {
          return toast.error('Error al descargar el archivo')
        }

        const binaryString = atob(response.payload.data)

        const len = binaryString.length
        const bytes = new Uint8Array(len)

        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }

        const url = window.URL.createObjectURL(
          new Blob([bytes], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
        )
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', response.payload.fileName)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
      })
    }
  }

  const handleClearFilters = () => {
    setFilterProps(initialFilterProps)
    reset()
  }

  const onSubmit = useCallback(() => {
    getData()
  }, [filterProps])

  return (
    <Fragment>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Card>
          <CardHeader className="flex-md-row flex-column align-md-items-center align-items-start border-bottom">
            <CardTitle tag="h4">Recepción de Documentos</CardTitle>
          </CardHeader>
          <Row
            className="mx-0"
            style={{ marginBlock: '1%', paddingLeft: '5%' }}
          >
            <Col
              md="5"
              sm="12"
            >
              <Label for="name">Nombre de emisor</Label>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <Input
                    id="name"
                    type="text"
                    {...field}
                    value={filterProps.name}
                    onChange={(event) => {
                      setFilterProps({
                        ...filterProps,
                        name: event.target.value,
                      })
                    }}
                  />
                )}
              />
            </Col>
            <Col
              md="5"
              sm="12"
            >
              <Label for="email">Correo de emisor</Label>
              <Controller
                name="email"
                control={control}
                render={({ field }) => (
                  <Input
                    id="email"
                    type="email"
                    {...field}
                    value={filterProps.email}
                    onChange={(event) =>
                      setFilterProps({
                        ...filterProps,
                        email: event.target.value,
                      })
                    }
                  />
                )}
              />
            </Col>
          </Row>
          <Row
            className="mx-0"
            style={{ marginBlock: '1%', paddingLeft: '5%' }}
          >
            <Col
              md="5"
              sm="12"
            >
              <Label className="me-1">Tipo de documento</Label>
              <Controller
                name="type"
                control={control}
                render={() => (
                  <Select
                    options={typeOptions}
                    value={filterProps.type}
                    onChange={(item) => {
                      setFilterProps({ ...filterProps, type: item })
                    }}
                  />
                )}
              />
            </Col>
            <Col
              md="5"
              sm="12"
            >
              <Label for="typeValue">Número de documento</Label>
              <Controller
                name="typeValue"
                control={control}
                render={({ field }) => (
                  <Input
                    id="typeValue"
                    type="text"
                    {...field}
                    value={filterProps.typeValue}
                    onChange={(event) =>
                      setFilterProps({
                        ...filterProps,
                        typeValue: event.target.value,
                      })
                    }
                  />
                )}
              />
            </Col>
          </Row>
          <Row
            className="mx-0"
            style={{ paddingLeft: '5%' }}
          >
            <Col
              md="5"
              sm="12"
            >
              <Label for="dteType">Tipo de DTE</Label>
              <Controller
                name="dteType"
                control={control}
                render={({ field }) => (
                  <Input
                    id="dteType"
                    type="text"
                    {...field}
                    value={filterProps.dteType}
                    onChange={(event) =>
                      setFilterProps({
                        ...filterProps,
                        dteType: event.target.value,
                      })
                    }
                  />
                )}
              />
            </Col>
          </Row>
          <Row
            className="mx-0"
            style={{ paddingLeft: '5%' }}
          >
            <Col
              md="5"
              sm="12"
            >
              <Label
                className="me-1"
                for="search-input"
              >
                Desde
              </Label>
              <div className="mb-50">
                <ResponsiveDatePickers
                  value={filterProps.startDate}
                  onChange={(date) =>
                    setFilterProps({ ...filterProps, startDate: date })
                  }
                  maxDate={filterProps.endDate}
                  Label=""
                  placeholder="Selecciona una fecha"
                  datePickerHeight="0px"
                />
              </div>
            </Col>

            <Col
              md="5"
              sm="12"
            >
              <Label
                className="me-1"
                for="search-input"
              >
                Hasta
              </Label>
              <div className="mb-50">
                <ResponsiveDatePickers
                  value={filterProps.endDate}
                  onChange={(value) =>
                    setFilterProps({ ...filterProps, endDate: value })
                  }
                  minDate={filterProps.startDate}
                  Label=""
                  placeholder="Selecciona una fecha"
                  datePickerHeight="0px"
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="d-flex align-items-center justify-content-sm-center mx-2 my-3">
              <Button
                className="mx-2"
                style={{ size: '10px', width: '200px' }}
                color="primary"
                type="submit"
                disabled={isPending}
              >
                Búsqueda
              </Button>
              <Button
                className="mx-2"
                style={{ size: '10px', width: '200px' }}
                color="primary"
                type="reset"
                onClick={handleClearFilters}
                disabled={isPending}
              >
                Limpiar Filtros
              </Button>
            </Col>
          </Row>
        </Card>
      </Form>

      {data.length > 0 && (
        <div className="d-flex justify-content-end mb-2 mx-2">
          <Button
            className=""
            style={{ size: '10px', width: '200px' }}
            color="primary"
            type="submit"
            onClick={getFile}
            disabled={isPending}
          >
            Descargar Reporte Excel
          </Button>
        </div>
      )}
    </Fragment>
  )
}
